import {
  DeviceAssociationGetAllResponse,
  DeviceAssociationSearchParams,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class DeviceUseStatementApi {
  getDeviceUseStatements = async (
    params: DeviceAssociationSearchParams
  ): Promise<DeviceAssociationGetAllResponse> =>
    await trpc.client.device.usage.getAll.query({ count: 20, ...params });
}
